import { createLocalization } from "@mhmo91/schmancy";
import { de } from "./backoffice.de.ts";
import { en } from "./backoffice.en.ts";

// Shares the one `i18n/locale` slot with @momo/views' engine, so the sign-in
// and this catalog always speak the same language.
export const { LocalizeMixin } = createLocalization(
	{ de, en },
	{ de: "de-DE", en: "en-GB" },
	{ defaultLocale: "de" },
);
